import type { APICitation, FollowupQuestion } from "./events";

export type Role = "user" | "assistant";

export type ResponseMessage = {
  content: string;
  role: Role;
};

export type ResponseChoice = {
  id: string;
  index: number;
  message: ResponseMessage;
  session_state: unknown;
  sessionId: string;
  feedback: string;
};

export type ChatAppResponse = {
  choices: ResponseChoice[];
  selected_agent: RAGAgent;
  recommendor_response: string;
  fallback_agent?: string;
  answer_attempt?: string;
  is_system_fallback?: string;
};

export type ConversationEntryData = {
  citations: APICitation[];
  otherLinks: APICitation[];
  followupQuestions: FollowupQuestion[];
};

export type ConversationEntry = [user: string, response?: ChatAppResponse, data?: ConversationEntryData];

export type ChatAppRequest = {
  sessionId?: string;
  messages: ResponseMessage[];
  stream?: boolean;
  session_state: unknown;
  system_prompt?: string;
};

export enum FeedbackBtnType {
  Inaccurate = "inaccurate",
  MissingInfo = "missing_info",
  OutOfDate = "out_of_date"
}

export type FeedbackData = {
  type?: FeedbackBtnType;
  reason?: string;
};

export type FeedbackStorage = Record<string, FeedbackData>;

export const isFeedbackBtnType = (value: unknown): value is FeedbackBtnType => {
  return Object.values(FeedbackBtnType).includes(value as FeedbackBtnType);
};

export const enum RAGAgent {
  Legislation = "legislation",
  FairTrading = "fair_trading",
  USU = "usu_knowledge_base"
}
